const initialState = {
    leaderboard: {
        allPromotions: null,
        leaderboardTableData: [],
        cache: {},
        error: null
    }
}

export default function leaderboard(state = initialState, action = {}) {
    switch (action.type) {
        case 'FETCH_ALL_PROMOTIONS':
            return {
                ...state,
                leaderboard: {
                    ...state.leaderboard,
                    allPromotions: action.payload.Data
                }
            };
        case 'FAILED_ALL_PROMOTIONS':
            return {
                ...state,
                leaderboard: {
                    ...state.leaderboard,
                    error: action.payload,
                }
            };
        case 'FETCH_LEADERBOARD_DATA':
            return {
                ...state,
                leaderboard: {
                    ...state.leaderboard,
                    leaderboardTableData: action.payload.Data,
                    cache: {
                        ...state.leaderboard.cache,
                        [action.cacheKey]: {
                            data: action.payload.Data
                        }
                    }
                }
            };
        case 'USE_CACHED_LEADERBOARD_DATA':
            return {
                ...state,
                leaderboard: {
                    ...state.leaderboard,
                    leaderboardTableData: state.leaderboard.cache[action.cacheKey].data
                }
            };
        case 'CLEAR_LEADERBOARD_CACHE':
            return {
                ...state,
                leaderboard: {
                    ...state.leaderboard,
                    cache: {}
                }
            };
            case 'FAILED_LEADERBOARD_DATA':
                return {
                    ...state,
                    leaderboard: {
                        ...state.leaderboard,
                        error: action.payload
                    }
                };
        default:
            return {
                ...state
            }
    }
}